import * as React from 'react';
import { Link } from 'react-router-dom';
import { formatCurrency } from 'utils/formatNumber';
import { ORGANIZATION_PACKAGES_PATH } from 'utils/paths';
import OrganizationPackage from 'types/organizationPackage';
import RemoveLeaguePackageModal from './leaguePackageCard/RemoveLeaguePackageModal';
import AddedOrganizationCapabilityPackages from './AddedOrganizationCapabilityPackages';

interface LeaguePackageWithDescription extends OrganizationPackage {
  packageDescription?: string;
}

interface Props {
  additionalHeaderLabel?: JSX.Element;
  organizationPackage: LeaguePackageWithDescription;
  mutation?: object;
}

const LeaguePackageCard: React.FunctionComponent<Props> = ({
  additionalHeaderLabel,
  organizationPackage,
  mutation,
}: Props) => {
  const {
    id,
    name,
    price,
    organizationCapabilityPackages,
    packageDescription,
  } = organizationPackage;

  return (
    <div
      className="card bg-lighter my-3"
      data-test={`organization-package-card-${id}`}
    >
      <div className="card-header row bg-success mx-0 px-3">
        <div className="col-1 p-0" />
        <div className="col-10 text-white text-center p-0">
          <h6 className="my-0">{name}</h6>
          <h1 className="my-0">{formatCurrency(price)}</h1>
          {!!packageDescription && (
            <div className="mt-2">{packageDescription}</div>
          )}
          {additionalHeaderLabel}
        </div>
        <div className="col-1 p-0 text-right">
          {!!mutation && (
            <RemoveLeaguePackageModal
              leaguePackage={organizationPackage}
              mutation={mutation}
            />
          )}
        </div>
      </div>
      <ul className="list-group list-group-flush">
        <AddedOrganizationCapabilityPackages
          organizationCapabilityPackages={organizationCapabilityPackages}
        />
      </ul>
      {!!mutation && (
        <div className="card-footer text-center">
          <Link
            className="font-weight-bold"
            to={`${ORGANIZATION_PACKAGES_PATH}/${id}`}
          >
            Update Package
          </Link>
        </div>
      )}
    </div>
  );
};

LeaguePackageCard.defaultProps = {
  additionalHeaderLabel: undefined,
  mutation: undefined,
};

export default LeaguePackageCard;
